import React from 'react';
import cx from 'classnames';
import styles from './pardotConfigurationView.module.scss';
import { toast } from 'react-toastify';
import LoadingMessage from 'src/legacy/components/LoadingMessage';
import { 
  Row, Col,
  FormGroup, InputGroup, FormControl, Form
} from 'react-bootstrap';
import SwitchButton from 'src/components/switchButton';
import SendButton from 'src/legacy/components/SendButton';
import PlaceholderEmptyMessage from 'src/legacy/components/PlaceholderEmptyMessage';
import AccessDeniedIcon from 'src/legacy/images/access_denied.svg';
import { localizedStrings } from 'src/localization/index.jsx';
import _ from 'lodash';
import Toast from 'src/components/toast';
class PardotConfigurationView extends React.Component {
  constructor(props){
    super(props);
    const integration = this.props.integration;

    this.state = {
      businessUnit: integration && integration.configuration.businessUnit || '',
      syncLeadCreatedEvent: integration && integration.configuration.syncLeadCreatedEvent || false,
      errors: {}
    }

    this._toggleSwitchChange = this._toggleSwitchChange.bind(this);
    this.handleBusinessIdChange = this.handleBusinessIdChange.bind(this);
    this._handleSaveChangesClicked = this._handleSaveChangesClicked.bind(this);
    this._handleResetClicked = this._handleResetClicked.bind(this);

    this.localizedIntegrations = localizedStrings.components.integrations;
    this.localizedCommons = localizedStrings.commons;
    this.localizedPardot = localizedStrings.components.integrations.pardot;
  }

  componentDidMount() {   
  }

  _toggleSwitchChange(field){

    this.setState({
      [field]: !this.state[field]
    });
  }

  _handleSaveChangesClicked(){
  
    let request = {
      businessUnit: this.state.businessUnit,
      syncLeadCreatedEvent: this.state.syncLeadCreatedEvent
    }

    this.props.updateConfiguration(request).then(() => {
        toast(
          <Toast.Sucess
            message = {this.localizedIntegrations.toast.pardot}            
          /> , {
            autoClose: 3000,
        })
    });
  }

  _handleResetClicked(){
    this.setState({
      businessUnit: this.props.integration.configuration.businessUnit,
      syncLeadCreatedEvent: this.props.integration.configuration.syncLeadCreatedEvent
    });
  }

  handleBusinessIdChange = (e) => {
    this.setState({
      businessUnit: e.target.value
    });
  }

  render(){
    return (
      <div className={styles.content}>
        {this.props.integration && this.props.integration.state.code === "auth_error" &&
          <span className={styles.authMessage}>
            {`${this.localizedIntegrations.integration_expired} ${this.props.integration.type}.`}
          </span>
        }

        {this.props.loading && this._renderLoading()}

        {!this.props.loading && this._renderAdminConfiguration()}

      </div>
    )
  }

  _renderAdminConfiguration() {
    return (
        <Row className={styles.row}>
          <Col md={8} mdOffset={1}>
            <div className={styles.form}>
              <p className={styles.errorMessage}>{this.state.errors && this.state.errors.apikey}</p>

              <FormGroup className={cx(styles.formGroup)}>
              <InputGroup className = {styles.disableEmail}>
                <div className={styles.start}>
                  <span>{ this.localizedPardot.pardot_business_unit_id }</span>
                </div>
                <FormControl
                  type='text'
                  placeholder={ this.localizedPardot.placeholder }
                  value={this.state.businessUnit}
                  onChange={this.handleBusinessIdChange}
                  disabled={!this.props.canEdit()} 
                />
              </InputGroup>
              </FormGroup>

              <FormGroup className={cx(styles.formGroup)}>
                <InputGroup>
                  <h5>{ this.localizedIntegrations.sync_events }</h5>
                </InputGroup>
              </FormGroup>
              <Form.Text>{ this.localizedPardot.config }</Form.Text>

              <FormGroup className={cx(styles.formGroup, styles.events)}>
                <div className={styles.event}>
                  <label>{ this.localizedIntegrations.configs.create_lead }</label>
                  <SwitchButton 
                    id="syncLeadCreatedEvent"
                    checked={this.state.syncLeadCreatedEvent}
                    handleCheck={()=>this._toggleSwitchChange("syncLeadCreatedEvent")} 
                    disabled={!this.props.canEdit()} 
                    className={styles.switch}
                    />
                </div>
              </FormGroup>

              {this.props.canEdit() && (
                <div className={styles.buttonTray}>
                <SendButton
                  className={cx(styles.save)}
                  icon="fa-chevron-right"
                  title={this.props.updating ? `${this.localizedCommons.actions.saving_changes}...` : this.localizedCommons.actions.save }
                  primary
                  disabled={this.props.updating}
                  onClick={this._handleSaveChangesClicked}
                >
                </SendButton>
                <SendButton
                  title={this.localizedCommons.actions.reset}
                  disabled={this.props.updating}
                  className={cx(styles.cancel)}
                  onClick={this._handleResetClicked}
                >
                </SendButton>
              </div>
              )}
            </div>
          </Col>
        </Row>
    );
  }

  _renderEmptyMessage() {
    return (
      <PlaceholderEmptyMessage
        title={this.localizedPardot.empty_message.title}
        message={this.localizedPardot.empty_message.sub_text}
        image={AccessDeniedIcon}
        className={styles.emptyMessage}
        visible={true}
      />
    );
  }

  _renderLoading() {
    return (
      <LoadingMessage 
        className={styles.loadingMessage}
        message={`${this.localizedPardot.loading}...`}
        visible={true} />
    )
  }
}

export default PardotConfigurationView;